import api from '../../api/index';
import wx from "weixin-js-sdk";
import config from '../../../static/config.json';
import {
  Toast
} from 'vant';


// 微信分享
const state = {
    order:{  // 创建本地订单
        actId:'', // 活动的id
        num:1, // 购票的数量
        totalPrice:0, // 总价
        title:'', // 名称
        joinMan:'', // 报名人
        regId:'', // 报名id
    },
}
const mutations = {
  setOrder(state, data) {
    state.order = data;
  },
}
const getters = {
  getOrder: (state) => {
    return state.order;
  },
}
const actions = {
  // 微信统一下单
  wechatPay({ rootState, commit } , opt) { 
    return new Promise((resolve, reject) => {
      api.post(`${config.https.api}/api/v1/wechatpay/unifiedorder`, opt, rootState.header).then(data => {
        if (data.data.result) { 
          resolve(data.data.data);
        }else{
          resolve(false);
        }
      }).catch((err) => {
        console.log(err);
        resolve(false);
      });
    });
  },

  /**
   * 调用微信支付
   * @param {*} {dispatch,getters}
   * @returns bool
   */
  // 微信支付 调取配置的页面路径，ios进入单页面应用时，保存的是首次进入的页面路径，导致在支付时报错路径没有配置；location.href刷新页面重新进入页面，支付配置的路径就没问题
  async payFor({ dispatch, getters },opt) {  
    // 微信支付
    let params = opt.parameter;
    console.log(params,'微信支付订单详情');
    return new Promise((resolve, reject) => {
      function onBridgeReady() {
        WeixinJSBridge.invoke(
          "getBrandWCPayRequest",
          {
            appId: params.appId, //公众号名称，由商户传入
            timeStamp: params.timeStamp, //时间戳，自1970年以来的秒数
            nonceStr: params.nonceStr, //随机串
            package: params.package,
            signType: params.signType, //微信签名方式：
            paySign: params.paySign //微信签名
          },
          function(res) { 
            console.log(res,'1111')
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              api.get(`${config.https.api}/api/v1/wechatpay/has-paid?orderId=${opt.orderId}&tradeType=${opt.tradeType}`).then(res=>{
                console.log(res,'支付结果');
                if(res.data.result){
                  resolve(true);
                } else {
                  resolve(false);
                }
              })
            }else {
              resolve(false);
              console.log('支付失败');
            } // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          }
        );
      }
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            onBridgeReady,
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
          document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
        }
      } else {
        onBridgeReady();
      }
    });
  },

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}

